export default "<div class=\"container-fluid\">\n  <div>\n    <app-search-orders></app-search-orders>\n  </div>\n</div>"